import {
    Directive, HostListener, Output, EventEmitter
  }
  from '@angular/core';
  
  @Directive({
    selector: '[scrollTracker]'
  })
  export class ScrollTrackerDirective {
    @Output() onEndReached = new EventEmitter();
    @HostListener('scroll', ['$event'])
    onScroll(event) {
      let tracker = event.target;
      let limit = tracker.scrollHeight - tracker.clientHeight;
      console.log(event.target.scrollTop, limit);
      if (event.target.scrollTop === limit) {
        this.onEndReached.emit();
      }
    }
  
    constructor() {
    }
  }


// WEBPACK FOOTER //
// ./src/app/shared/components/ScrollTrackerDirective/ScrollTrackerDirective.ts